// @flow
import * as React from 'react';
import styled from 'styled-components';
import type { PromotionState } from '../modules/promotions/reducers/promotionReducer';

const TabWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const Tab = styled.div`
  color: ${({ active, theme }) => (active ? theme.colors.primary : theme.colors.primaryText)};
  font-weight: ${({ active, theme }) => (active ? theme.fonts.weights.normal : theme.fonts.weights.lighter)};
  font-size: ${({ theme }) => theme.fonts.style.sub.fontSize}px;

  border-bottom: 2px solid ${({ active, theme }) => (active ? theme.colors.primary : 'transparent')};
  padding-bottom: ${({ theme }) => theme.metrics.tinyMargin}px;

  :hover {
    cursor: pointer;
  }
`;

export type TabEntry = {
  value: PromotionState;
  label: string;
}

type Props = {
  tabs: TabEntry[];
  currentTab: PromotionState;
  onChangeTab: (tab: PromotionState) => any;
}

function TabPicker({ tabs, currentTab, onChangeTab }: Props) {
  return (
    <TabWrapper>
      {tabs.map(entry => <Tab onClick={() => onChangeTab(entry.value)} key={entry.value} active={entry.value === currentTab}>{entry.label}</Tab>)}
    </TabWrapper>
  );
}

export default TabPicker;



// WEBPACK FOOTER //
// ./src/statsradio/components/TabPicker.js